import { useContext, useEffect } from 'react';

import cookie from 'cookie';
import { useLocation } from 'react-router-dom';

import { AuthContext } from '@App/contexts/Auth';
import { ApplicationContext } from '@src/app/contexts/Application';

import AuthLayout from '../layouts/AuthLayout';
import CreateUserView from '../views/auth/CreateUserView';

const buttonText: Record<string, string> = {
    create_account: 'Get your quote',
    save_for_later: 'Save my application',
};

const CreateUser = () => {
    const { register, loading, setLoading } = useContext(AuthContext);
    const { setExternalApplicationId } = useContext(ApplicationContext);
    const location = useLocation();
    const flow =
        (location.state as { intent: string } | undefined)?.intent || 'default';
    const search = location.search;

    useEffect(() => {
        setLoading(false);
    }, [setLoading]);

    const cookies = cookie.parse(document.cookie);
    const appInfo = cookies.application ? JSON.parse(cookies.application) : {};

    // the + in an email was being replaced by a space
    const email = (
        new URLSearchParams(search).get('email') ||
        appInfo.emailAddress ||
        ''
    ).replace(/ /g, '+');

    const url = new URL(window.location.href);
    const urlExternalApplicationId = url.searchParams.get(
        'externalApplicationId',
    );

    useEffect(() => {
        if (urlExternalApplicationId) {
            setExternalApplicationId(urlExternalApplicationId);
            localStorage.setItem(
                'externalApplicationId',
                urlExternalApplicationId,
            );
        }
    }, [setExternalApplicationId, urlExternalApplicationId]);

    return (
        <AuthLayout
            title={flow === 'default' ? 'Create account' : undefined}
            loading={loading}
        >
            <CreateUserView
                register={register}
                email={email}
                buttonText={buttonText[flow]}
            />
        </AuthLayout>
    );
};

export default CreateUser;
